export enum STAY_STATUS {
  CHECKED_IN = 'CheckedIn',
  CHECKED_OUT = 'CheckedOut',
  CONFIRMED = 'Confirmed',
}

export type StayStatusProps = {
  status: STAY_STATUS;
};
